module.exports = __webpack_public_path__ + "img/camerak.b5a75793.png";